import { render, staticRenderFns } from "./signUpPopup.vue?vue&type=template&id=51cfa8a2&scoped=true&"
import script from "./signUpPopup.vue?vue&type=script&lang=js&"
export * from "./signUpPopup.vue?vue&type=script&lang=js&"
import style0 from "./signUpPopup.vue?vue&type=style&index=0&id=51cfa8a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cfa8a2",
  null
  
)

export default component.exports